export enum ActivityType {
  InformationRequestUpdated = 52,
  InformationRequestSent = 53,
  InformationRequestRecipientAssigned = 54,
  InformationRequestRecipientMessage = 57,
  InformationRequestMessageSent = 58,
  InformationRequestRespondToMessageAction = 59,
  InformationRequestUploadDocumentsAction = 60,
  InformationRequestReadDocumentsAction = 61,
  InformationRequestRecipientMessageAO = 62,
  InformationRequestMessageSentAO = 63,
  InformationRequestUpdateRecipientsAO = 64,
  InformationRequestRecipientClosedAO = 65,
  InformationRequestRecipientClosedOfqual = 66,
  InformationRequestAssignedAO = 67,
  InformationRequestRecipientAssignedChild = 85,
  InformationRequestRemoveRecipientsAO = 87,
  InformationRequestSentChild = 88,
}


export const allActivityTypes = [
  ActivityType.InformationRequestUpdated,
  ActivityType.InformationRequestSent,
  ActivityType.InformationRequestRecipientAssigned,
  ActivityType.InformationRequestRecipientMessage,
  ActivityType.InformationRequestMessageSent,
  ActivityType.InformationRequestRespondToMessageAction,
  ActivityType.InformationRequestUploadDocumentsAction,
  ActivityType.InformationRequestReadDocumentsAction,
  ActivityType.InformationRequestRecipientMessageAO,
  ActivityType.InformationRequestMessageSentAO,
  ActivityType.InformationRequestUpdateRecipientsAO,
  ActivityType.InformationRequestRecipientClosedAO,
  ActivityType.InformationRequestRecipientClosedOfqual,
  ActivityType.InformationRequestAssignedAO,
  ActivityType.InformationRequestRecipientAssignedChild,
  ActivityType.InformationRequestRemoveRecipientsAO,
  ActivityType.InformationRequestSentChild,
]